import React from 'react'
import AppButton from '../AppButton/AppButton'
import { useEffect } from 'react'

interface Props {
    isOpen: boolean
    title: string
    description?: string
    buttonSubmitText?: string
    buttonCancelText?: string
    type?: string
    onClose?: () => void
    handleConfirm: () => void
    confirmVariant?: 'danger' | 'primary'
}

const AppModalConfirmation = ({
    title,
    description,
    isOpen,
    onClose,
    handleConfirm,
    buttonSubmitText = 'Confirmar',
    buttonCancelText = 'Cancelar',
    confirmVariant = 'danger',
}: Props) => {
    const isPrimary = confirmVariant === 'primary'
    useEffect(() => {
        if (isOpen) {
            document.body.style.pointerEvents = 'none'
        } else {
            document.body.style.pointerEvents = 'auto'
        }
        return () => {
            document.body.style.pointerEvents = 'auto'
        }
    }, [isOpen])

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
                    <div className="absolute inset-0 bg-black bg-opacity-40" />
                    <div
                        className="relative bg-white rounded-lg shadow-xl w-full max-w-md mx-4 pointer-events-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center px-6 py-4">
                            <h2 className="text-xl font-semibold text-[#141A1F]">
                                {title}
                            </h2>
                            <img
                                src={require('../../../assets/Close.png')}
                                alt="Close"
                                className="img-logo cursor-pointer"
                                onClick={onClose}
                            />
                        </div>

                        <hr className="border-[#CBD5E1]" />

                        {description && (
                            <div className="px-6 py-6">
                                <p
                                    className={
                                        isPrimary
                                            ? 'text-base text-left text-[#141A1F] leading-[20px] font-normal'
                                            : 'text-base text-center text-gray-700 leading-relaxed font-medium'
                                    }
                                >
                                    {description}
                                </p>
                            </div>
                        )}
                        <div className="flex justify-end gap-3 px-6 pb-6">
                            {onClose && (
                                <AppButton
                                    title={buttonCancelText}
                                    onClick={onClose}
                                    state="ghost"
                                    className={
                                        isPrimary
                                            ? '!text-[16px] !leading-[20px] !text-[#141A1F] font-semibold min-w-[96px]'
                                            : 'bg-white border border-gray-300 text-[#141A1F] font-medium'
                                    }
                                />
                            )}
                            <AppButton
                                title={buttonSubmitText}
                                onClick={handleConfirm}
                                state={isPrimary ? 'primary' : 'danger'}
                                className={
                                    isPrimary
                                        ? '!text-[16px] !leading-[20px] font-semibold min-w-[96px] drop-shadow-[0px_3px_3px_rgba(148,163,184,0.15)]'
                                        : 'text-white font-semibold'
                                }
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default AppModalConfirmation
